var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHopiPay = function SvgHopiPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.942 10c3.364-.019 6.064 2.64 6.058 5.968-.006 3.287-2.675 6.005-5.925 6.032-3.298.03-6.046-2.689-6.075-6.004-.027-3.257 2.665-5.975 5.942-5.996Z",
    fill: "#EB018C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.947C.358 7.214 1.414 6.04 3.044 5.369c2.404-.994 5.259.09 6.43 2.407 1.187 2.346.299 5.233-2.01 6.542-2.315 1.314-5.126.683-6.652-1.494-.002-.183-.046-.34-.255-.395 0 0 .01.014.012.014L0 8.947Z",
    fill: "#39B54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.476c.007-2.472 1.973-4.467 4.412-4.476 2.56-.009 4.635 2.055 4.587 4.561C40.953 18.987 38.91 21 36.493 21c-2.482.002-4.5-2.03-4.493-4.524Z",
    fill: "#03AEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.222 8c.258 1.334.52 2.666.778 4C-.014 10.766-.224 9.425.222 8ZM.95 11.95c.082.013.1.054.1.1a18.29 18.29 0 0 0-.1-.1Z",
    fill: "#44B955"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F6941E",
    cx: 29.5,
    cy: 4.5,
    r: 4.5
  }))));
};

export default SvgHopiPay;